import { render, staticRenderFns } from "./RecoverTfa.vue?vue&type=template&id=d8378934&scoped=true&"
import script from "./RecoverTfa.vue?vue&type=script&lang=js&"
export * from "./RecoverTfa.vue?vue&type=script&lang=js&"
import style0 from "./RecoverTfa.vue?vue&type=style&index=0&id=d8378934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8378934",
  null
  
)

export default component.exports